import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from './../actions/user_actions';
import { ModalDialogCommon } from './modal_dialog_common';
import { bindActionCreators } from 'redux';
import { validate } from '../validations';

let ForgotPassword = React.createClass({
    getInitialState() {
        return {
            someState: '',
            modal: false,
            message: null,
            isSubmited: false
        }
    },
    componentWillReceiveProps(nextProps) {

        var getPwdStatus = nextProps.passwordDetail;
        this.setState({ modal: true });
        getPwdStatus ? this.setState({ message: getPwdStatus.message }) : "";
    },
    componentDidMount() {

    },

    handelClick() {
        let isValidUserName = (this.refs.userName.value.trim().length > 0);
        isValidUserName ? this.refs.userName.className = 'inputText' : this.refs.userName.className = 'inputText error';

        let isValidEmail = validate.email(this.refs.email.value);
        isValidEmail ? this.refs.email.className = 'inputText' : this.refs.email.className = 'inputText error';

        if (this.refs.userName.value.trim().length == 0 && this.refs.email.value.trim().length == 0) {
            this.setState({ modal: true, message: "Please enter necessary fields to proceed." });
            return false;
        }

        var data = {};

        if (isValidUserName && isValidEmail) {
            data.userName = this.refs.userName.value.trim();  //+ '/0'; // + '/0' -> for request identifier for web app.
            data.email = this.refs.email.value.trim();
            this.props.Dispatch(UserActions.forgotPasword(data));
            this.setState({ isSubmited: true });

        }
        else {
            this.setState({ modal: true, message: "Please enter valid information to proceed." }); return false;
        }

    },
    sendBack() {
        this.props.router.push('/');
    },
    closebox() {
        this.state.isSubmited && this.props.passwordDetail && this.props.passwordDetail.status === 200 ? this.props.router.push('/') : this.setState({ modal: false, isSubmited: false });
        //this.refs.email.value="";
        //this.refs.userName.value="";

    },
    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.handelClick();
        }

    },

    no_empty(event) {
        event.target.value.trim().length > 0 ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    email_validate(event) {
        validate.email(event.target.value) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    remove_error(event) {
        event.target.type === "text" ? event.target.className = 'inputText' : event.target.className = '';
    },

    render() {
        return (
            <div className="vertalign-container">

                <div className="vertalign-child">
                    <h1 className="top-logo">MOBI</h1>
                    <div className="admin-login forgot-password">
                        <span onClick={this.sendBack} className="icon-backarrow"></span>
                        <p className="login-head">Forgot your password?</p>
                        <p>Enter your Email address and Username below and we'll get you back on track.</p>
                        <div className="input-group">
                            <input type="text" className="inputText" required ref="email" onFocus={this.remove_error} onBlur={this.email_validate} />
                            <span className="floating-label">Email</span>
                        </div>
                        <div className="input-group">
                            <input type="text" className="inputText" required ref="userName" onKeyPress={this.handleKeyPress} onFocus={this.remove_error} onBlur={this.no_empty} />
                            <span className="floating-label">Username</span>
                        </div>


                        <button className="gray-button admin-login-button" onClick={this.handelClick}>REQUEST A LINK</button>
                    </div>
                </div>
                <div> {this.state.modal ? <ModalDialogCommon message={this.state.message} action={this.closebox} /> : ""}</div>
            </div>


        );
    }
});

let mapStateToProps = (state) => {
    return {
        passwordDetail: state.User.PasswordDetail,
    };
};

let mapDispatchToProps = (dispatch) => ({
    // UserActions: bindActionCreators(UserActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(ForgotPassword));



/** WEBPACK FOOTER **
 ** ./src/components/forgotpassword.js
 **/